import { render, staticRenderFns } from "./UserOffers.vue?vue&type=template&id=2a6464dd&"
import script from "./UserOffers.vue?vue&type=script&lang=js&"
export * from "./UserOffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports